import { create } from 'zustand';

interface LoadingState {
  isRouteLoading: boolean;
  isApiLoading: boolean;
  apiLoadingMessage?: string;
  setRouteLoading: (loading: boolean) => void;
  setApiLoading: (loading: boolean, message?: string) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isRouteLoading: false,
  isApiLoading: false,
  apiLoadingMessage: undefined,
  setRouteLoading: (loading) => set({ isRouteLoading: loading }),
  setApiLoading: (loading, message) => 
    set({ isApiLoading: loading, apiLoadingMessage: message }),
}));
